import { render, staticRenderFns } from "./FooterBannerList.vue?vue&type=template&id=25dfda1a&scoped=true"
import script from "./FooterBannerList.vue?vue&type=script&lang=js"
export * from "./FooterBannerList.vue?vue&type=script&lang=js"
import style0 from "./FooterBannerList.vue?vue&type=style&index=0&id=25dfda1a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25dfda1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25dfda1a')) {
      api.createRecord('25dfda1a', component.options)
    } else {
      api.reload('25dfda1a', component.options)
    }
    module.hot.accept("./FooterBannerList.vue?vue&type=template&id=25dfda1a&scoped=true", function () {
      api.rerender('25dfda1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/advertising/FooterBannerList.vue"
export default component.exports